import { createContext } from 'react';

type DragAndDropUploadContextProps = {
  openDragAndDropUploadModal: () => void;
};

export default createContext<DragAndDropUploadContextProps>({
  openDragAndDropUploadModal: () => undefined,
});
